const DataMaintenance = [
    {
        path: "/wcp/data/maintenance/basin",
        name: "Basin",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6d41\u57df\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/basin/Basin"),
        }
    },
    {
        path: "/wcp/data/maintenance/basin/modify",
        name: "BasinModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6d41\u57df\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/basin/BasinModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/river",
        name: "River",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6cb3\u6d41\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/river/River"),
        }
    },
    {
        path: "/wcp/data/maintenance/river/modify",
        name: "RiverModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6cb3\u6d41\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/river/RiverModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/reservoir",
        name: "Reservoir",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6c34\u5e93\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/reservoir/Reservoir"),
        }
    },
    {
        path: "/wcp/data/maintenance/reservoir/modify",
        name: "ReservoirModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6c34\u5e93\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/reservoir/ReservoirModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/reservoir/curve/modify",
        name: "CurveModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6c34\u5e93\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/reservoir/features/curve/CurveModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/dam",
        name: "Dam",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5927\u575d\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/dam/Dam"),
        }
    },
    {
        path: "/wcp/data/maintenance/dam/modify",
        name: "DamModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5927\u575d\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/dam/DamModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/station",
        name: "Station",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6d4b\u7ad9\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/station/basic/Station"),
        }
    },
    {
        path: "/wcp/data/maintenance/station/modify",
        name: "StationModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6d4b\u7ad9\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/station/basic/StationModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/station/monitor/point/modify",
        name: "MonitorPointModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6d4b\u70b9\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/station/basic/components/MonitorPointModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/station/features",
        name: "Features",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u7279\u5f81\u503c', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/station/features/index"),
        }
    },
    {
        path: "/wcp/data/maintenance/station/features/curve/modify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u7279\u5f81\u503c-\u66f2\u7ebf', requireAuth: true },
        name: "CurveModify1",
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/station/features/curve/CurveModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/station/features/flood/control/level/modify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u7279\u5f81\u503c-\u6c5b\u9650\u6c34\u4f4d', requireAuth: true },
        name: "FloodControlLevelModify",
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/station/features/flood-control-level/FloodControlLevelModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/multimedia",
        name: "Multimedia",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5f71\u50cf\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/multimedia/Multimedia"),
        }
    },
    {
        path: "/wcp/data/maintenance/multimedia/modify",
        name: "MultimediaModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5f71\u50cf\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/multimedia/MultimediaModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/broadcast",
        name: "Broadcast",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5e7f\u64ad\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/broadcast/Broadcast"),
        }
    },
    {
        path: "/wcp/data/maintenance/broadcast/modify",
        name: "BroadcastModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5e7f\u64ad\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/broadcast/BroadcastModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/region",
        name: "Region",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u884c\u653f\u533a\u5212', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/region/Region"),
        }
    },
    {
        path: "/wcp/data/maintenance/region/modify",
        name: "RegionModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u884c\u653f\u533a\u5212', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/base-info/region/RegionModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/organization",
        name: "Organization",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5355\u4f4d\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/organization/unit/Unit"),
        }
    },
    {
        path: "/wcp/data/maintenance/organization/modify",
        name: "OrganizationModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u5355\u4f4d\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/organization/unit/UnitModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/department",
        name: "Department",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u90e8\u95e8\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/organization/department/Department"),
        }
    },
    {
        path: "/wcp/data/maintenance/department/modify",
        name: "DepartmentModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u90e8\u95e8\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/organization/department/DepartmentModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/personnel",
        name: "Personnel",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u90e8\u95e8\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/organization/personnel/Personnel"),
        }
    },
    {
        path: "/wcp/data/maintenance/personnel/modify",
        name: "PersonnelModify",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u90e8\u95e8\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/organization/personnel/PersonnelModify"),
        }
    },
    {
        path: "/wcp/data/maintenance/data/report/report",
        name: "DataReportIndex",
        meta: { title: '\u6570\u636e\u7ba1\u7406-\u6570\u636e\u62a5\u8868', requireAuth: true },
        components: {
            left: () => import("@/views/data-maintenance/navigation/NavigationBar"),
            main: () => import("@/views/data-maintenance/data-report/report/index"),
        }
    }
]

export default DataMaintenance;


// WEBPACK FOOTER //
// ./src/router/data-maintenance.js